import { VALIDATION_DATA_MISSING } from '../constants/api-error-enums';
import ValidationData from '../schemas/validation-data';
import constructValidationMessage from './construct-validation-message';

const validateCompleteIdentityValidationData = data => {
  const { error } = ValidationData.validate(data, { abortEarly: false });
  let reason;
  const VALIDATION_DATA_MISSING_ERROR =
    error && error.details.some(o => o.context.label === 'value');
  if (VALIDATION_DATA_MISSING_ERROR) {
    reason = VALIDATION_DATA_MISSING;
  }
  return constructValidationMessage(error, 'completeIdentityValidation()', reason);
};

export default validateCompleteIdentityValidationData;
